import { render, staticRenderFns } from "./WorkoutLogStat.vue?vue&type=template&id=33f4b949&scoped=true"
import script from "./WorkoutLogStat.vue?vue&type=script&lang=js"
export * from "./WorkoutLogStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f4b949",
  null
  
)

export default component.exports